import { createEnv } from '@t3-oss/env-nextjs';
import { vercel } from '@t3-oss/env-nextjs/presets-zod';
import { z } from 'zod';

export const env = createEnv({
  shared: {
    NODE_ENV: z
      .enum(['development', 'production', 'test'])
      .default('development'),
  },
  client: {
    NEXT_PUBLIC_SITE_NAME: z.enum(['tilecloud', 'yabby', 'trade', 'dawn']),
    NEXT_PUBLIC_SANITY_API_VERSION: z.string().min(1),
    NEXT_PUBLIC_SANITY_PROJECT_ID: z.string().min(1),
    NEXT_PUBLIC_SANITY_DATASET: z.string().min(1),
    NEXT_PUBLIC_SHOPIFY_CUSTOMER_SHOP_ID: z.string().min(1),
    NEXT_PUBLIC_KLAVIYO_PUBLIC_KEY: z.string().min(1),
    NEXT_PUBLIC_AXIOM_DATASET: z.string().optional(),
    NEXT_PUBLIC_AXIOM_TOKEN: z.string().optional(),
    NEXT_PUBLIC_OKENDO_SUBSCRIBER_ID: z.string().optional(),
  },
  server: {
    DEAR_APPLICATION_KEY: z.string().min(1),
    DEAR_ACCOUNT_ID: z.string().min(1),
    RESEND_API_KEY: z.string().min(1),
    SANITY_API_READ_TOKEN: z.string().min(1),
    SANITY_API_ADMIN_TOKEN: z.string().min(1),
    SANITY_WEBHOOK_SECRET: z.string().min(1).optional(),
    SHOPIFY_CUSTOMER_CLIENT_SECRET: z.string().min(1),
    SHOPIFY_CUSTOMER_CLIENT_ID: z.string().min(1),
    SHOPIFY_STORE_DOMAIN: z.string().min(1),
    SHOPIFY_STOREFRONT_ACCESS_TOKEN: z.string().min(1),
    SHOPIFY_ADMIN_API_TOKEN: z.string().min(1),
    KLAVIYO_API_KEY: z.string().min(1),
    KLAVIYO_NEWSLETTER_LIST_ID: z.string().min(1),
    GTM_ID: z.string().min(1),
    SLACK_API_TOKEN: z.string().min(1),
    SWISH_API_TOKEN: z.string().min(1).optional(),
  },
  runtimeEnv: {
    DEAR_APPLICATION_KEY: process.env.DEAR_APPLICATION_KEY,
    DEAR_ACCOUNT_ID: process.env.DEAR_ACCOUNT_ID,
    NODE_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_SITE_NAME: process.env.NEXT_PUBLIC_SITE_NAME,
    NEXT_PUBLIC_SANITY_API_VERSION: process.env.NEXT_PUBLIC_SANITY_API_VERSION,
    NEXT_PUBLIC_SANITY_PROJECT_ID: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
    NEXT_PUBLIC_SANITY_DATASET: process.env.NEXT_PUBLIC_SANITY_DATASET,
    NEXT_PUBLIC_SHOPIFY_CUSTOMER_SHOP_ID:
      process.env.NEXT_PUBLIC_SHOPIFY_CUSTOMER_SHOP_ID,
    NEXT_PUBLIC_KLAVIYO_PUBLIC_KEY: process.env.NEXT_PUBLIC_KLAVIYO_PUBLIC_KEY,
    NEXT_PUBLIC_AXIOM_DATASET:
      process.env.NODE_ENV === 'production'
        ? process.env.NEXT_PUBLIC_AXIOM_DATASET
        : undefined,
    NEXT_PUBLIC_AXIOM_TOKEN:
      process.env.NODE_ENV === 'production'
        ? process.env.NEXT_PUBLIC_AXIOM_TOKEN
        : undefined,
    NEXT_PUBLIC_OKENDO_SUBSCRIBER_ID:
      process.env.NEXT_PUBLIC_OKENDO_SUBSCRIBER_ID,
    RESEND_API_KEY: process.env.RESEND_API_KEY,
    SANITY_API_READ_TOKEN: process.env.SANITY_API_READ_TOKEN,
    SANITY_API_ADMIN_TOKEN: process.env.SANITY_API_ADMIN_TOKEN,
    SANITY_WEBHOOK_SECRET: process.env.SANITY_WEBHOOK_SECRET,
    SHOPIFY_CUSTOMER_CLIENT_SECRET: process.env.SHOPIFY_CUSTOMER_CLIENT_SECRET,
    SHOPIFY_CUSTOMER_CLIENT_ID: process.env.SHOPIFY_CUSTOMER_CLIENT_ID,
    SHOPIFY_STORE_DOMAIN: process.env.SHOPIFY_STORE_DOMAIN,
    SHOPIFY_STOREFRONT_ACCESS_TOKEN:
      process.env.SHOPIFY_STOREFRONT_ACCESS_TOKEN,
    SHOPIFY_ADMIN_API_TOKEN: process.env.SHOPIFY_ADMIN_API_TOKEN,
    KLAVIYO_API_KEY: process.env.KLAVIYO_API_KEY,
    KLAVIYO_NEWSLETTER_LIST_ID: process.env.KLAVIYO_NEWSLETTER_LIST_ID,
    GTM_ID: process.env.GTM_ID,
    SLACK_API_TOKEN: process.env.SLACK_API_TOKEN,
    SWISH_API_TOKEN: process.env.SWISH_API_TOKEN,
  },
  extends: [vercel()],
});
